import { EXECUTION_STATUS_CATEGORY, statusMapping } from "features/shared/lib/configs";
import { ExecutionStatus } from "features/shared/model/types";
import { isNumeric } from "utils/dataManipulation";
import { percent } from "utils/textSymbols";

import type { ExecutionStep } from "../model/types";

export const formatProgressPercent = (progress?: null | number): string => {
  if (!isNumeric(progress)) return "---";

  return `${progress}${percent}`;
};

const isTerminalStepStatus = (status: ExecutionStatus): boolean => {
  return EXECUTION_STATUS_CATEGORY[statusMapping[status]]?.isTerminal ?? false;
};

export const getLastStepMessage = (steps?: ExecutionStep[]): string | undefined => {
  if (!steps?.length) return undefined;

  for (let index = steps.length - 1; index >= 0; index -= 1) {
    const step = steps[index];
    if (!isTerminalStepStatus(step.status)) continue;

    const message = step.message?.trim();
    if (message) return message;
  }

  return undefined;
};
